import { render, staticRenderFns } from "./warehouseInfo.vue?vue&type=template&id=62583dfe&scoped=true"
import script from "./warehouseInfo.vue?vue&type=script&lang=js"
export * from "./warehouseInfo.vue?vue&type=script&lang=js"
import style0 from "./warehouseInfo.vue?vue&type=style&index=0&id=62583dfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62583dfe",
  null
  
)

export default component.exports